import { render } from "./SuccessButton.vue?vue&type=template&id=0659f1df"
import script from "./SuccessButton.vue?vue&type=script&lang=js"
export * from "./SuccessButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__